/**
 * Trigger: tr_account_initial_balances_delete
 * Purpose: Update account balances when an initial balance is hard deleted
 * Table: account_initial_balances
 * Event: BEFORE DELETE
 */
export const TR_ACCOUNT_INITIAL_BALANCES_DELETE = `
CREATE TRIGGER tr_account_initial_balances_delete
BEFORE DELETE ON account_initial_balances FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET initial_balance = 0
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET initial_balance = 0
  WHERE old.is_deleted = 0
    AND old.initial_balance > 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.balance_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
